import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

function clearAuthSessionAndRedirectHome(): void {
    localStorage.removeItem('@7Cantos:token');
    localStorage.removeItem('@7Cantos:user');
    localStorage.removeItem('@7Cantos:dateToExpires');
    localStorage.removeItem('@7Cantos:consultants');

    window.location.href = `${window.location.origin}/`;
}

api.interceptors.response.use((response) => {
    if(response.data?.role === 'client'){
        clearAuthSessionAndRedirectHome();
    };

    return response;
}, (err) => {
    if(!!err.response){
        // 403 = forbidden for this action, not necessarily invalid session.
        // Logging out on every 403 (e.g. missing schedule permission or new API routes)
        // was forcing users back to login after a successful sign-in.
        if(err.response.status === 401){
            clearAuthSessionAndRedirectHome();
        };
    }
    
    return Promise.reject(err);
});

export default api;
